import React from "react";
import UserPointState, { UserPointProps } from "./UserPoint.models";
import './UserPoint.scss';
import PointsService from "../../../services/management/PointsService";
import { NavLink } from "react-router-dom";
import RowField from "../../shared/row-field/RowField";
import successImage from '../../../assest/images/card-image/points-plus-emp.png';

export default class UserPoint extends React.PureComponent<UserPointProps, UserPointState>{
    pointsService: PointsService;
    constructor(props: any) {
        super(props);
        this.pointsService = new PointsService();
        this.state = { pointCount: { currentPoint: 0, totalPoint: 0 } };
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let self = this;
        self.pointsService.getPointsCount().then(function (response) {
            self.setState({ pointCount: response });
        });
    }

    render(): React.ReactNode {
        let { pointCount } = this.state;
        return (<>
            <div className="col-12 user-point-area notspace margin-top box-shadow">
                <div className="tk-inline card-boundel">
                    <div className="col-2 notspace">
                        <div className="points success-images">
                            <label className="mdi mdi-star star"></label>
                        </div>
                    </div>
                    <div className="col-8 notspace" style={{ textAlign: "right", marginRight: "20px" }}>
                        <div className="pd-detail">
                            <div className="course-title">
                                <label>مجموع امتیازات من </label>

                            </div>
                            <div className="course-subtitle">
                                <label>{pointCount.currentPoint} امتیاز</label>
                            </div>
                        </div>
                    </div>
                    <NavLink to={"/PointsGuide"} className="col-2 notspace" style={{ left: "15px", top: "18px" }}>
                        <span className="mdi mdi-help-circle-outline" style={{ fontSize: "25px", color: "orange", cursor: "pointer" }}></span>
                    </NavLink>
                </div>
            </div>

            <RowField wordRestrictionLeghnt={16} details={{ title: "کل امتیازات کسب شده", subTitle: `${pointCount.totalPoint} امتیاز`, imageSource: successImage,showButton:false }} children={<label className="mdi mdi-star field-icon"></label>} />
        </>);
    }

}